import AxiosClient from '../../../functional/Axios/AxiosClient';

const apiForgotPasswordPath = '/users';

export const forgotPassword = (payload) => AxiosClient.post(`${apiForgotPasswordPath}/forgotpassword`, {
  email: payload.email,
})
  .then((result) => result)
  .catch((errors) => errors);
